import { Stack } from '@mui/material';
import React, { cloneElement, isValidElement } from 'react';

import { ArrowDownIcon } from '@/shared/assets/icons/arrow-down-icon';
import { ArrowUpIcon } from '@/shared/assets/icons/arrow-up-icon';

import { StyledSelectedButton } from './select-button.styled';
import { TSelectButton } from './select-button.types';

export const SelectButton: React.FC<TSelectButton> = ({
  variant,
  clicked,
  active,
  icon,
  children,
  alignLabelLeft,
  ...props
}) => {
  const renderIcon = () => {
    if (!isValidElement<React.HTMLAttributes<HTMLElement>>(icon)) {
      return icon;
    }
    return cloneElement(icon, { className: 'select-button-icon' });
  };

  const renderContent = () => {
    if (alignLabelLeft) {
      return (
        <Stack gap="0.5rem" direction="row" alignItems="center">
          {renderIcon()}
          {children}
        </Stack>
      );
    }

    return (
      <>
        {renderIcon()}
        {children}
      </>
    );
  };

  return (
    <StyledSelectedButton
      $variant={variant}
      $clicked={clicked}
      $active={active}
      {...props}
    >
      {renderContent()}
      {clicked ? (
        <ArrowUpIcon className="select-button-arrow" />
      ) : (
        <ArrowDownIcon className="select-button-arrow" />
      )}
    </StyledSelectedButton>
  );
};
